import useEdgeMutation from '@app/data/edge/hooks/useEdgeMutation';
import type { UpdateFavoriteProductMutation } from '../mutations/__generated__/updateFavoriteProduct.types';
import { UPDATE_FAVORITE_PRODUCTS } from '../mutations';

const useUnfavoriteProduct = () => {
  const { mutatefn, data, error, loading } =
    useEdgeMutation<UpdateFavoriteProductMutation>(UPDATE_FAVORITE_PRODUCTS);

  return {
    data,
    error,
    loading,
    unfavoriteProduct: mutatefn,
  };
};

export default useUnfavoriteProduct;
